<template>
  <section class="content">
      <div class='box box-info'>
        <div class="p-toolbar p-component mb-4">
        <billsundrypurchaseDialog ref="openDialog"/>
      </div>
        <purchaseExtraExpensesList @delete-message="deleteMessage" @edit-account="editExtraExpenses"/>
      </div>
  </section>
</template>
<script>
import purchaseExtraExpensesList from './purchaseExtraExpensesList.vue'
import billsundrypurchaseDialog from '../billSundryDialog/billSundryPurchaseDialog.vue'

export default {
  name: 'billsundrypurchase',
  methods: {
    editExtraExpenses(data) {
      this.$refs.openDialog.editExtraExpenses(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    purchaseExtraExpensesList,
    billsundrypurchaseDialog
  }
}
</script>



// WEBPACK FOOTER //
// BillSundryPurchase.vue?0b5e9e39